import { Controller } from '@hotwired/stimulus'
import Highcharts from 'highcharts'

export default class extends Controller {
  static values  = { title: String, data: String }

  connect() {
    this.initChart()
  }

  initChart() {
    this.chart = Highcharts.chart(this.element, {
      title: { text: this.titleValue, align: 'center', verticalAlign: 'middle', x: 0, y: 80 },
      plotOptions: {
        pie: {
          startAngle: -90, endAngle: 90, center: ['50%', '75%'],
          dataLabels: { enabled: true, distance: -50,  style: { fontSize: '25px' } }
        }
      },
      tooltip: { pointFormat: '<strong>{point.percentage:.1f}%</strong>' },
      navigation: { buttonOptions: { enabled: false } },
      series: [{
        type: 'pie',
        innerSize: '40%',
        data: JSON.parse(this.dataValue.replaceAll("'", '"'))
      }]
    })
  }
}
